import { useEffect } from 'react';
import { FaCheck } from 'react-icons/fa6';

import Cal, { getCalApi } from '@calcom/embed-react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@frontend/components/ui/dialog';
import { useDirectoryMe } from '@frontend/shared/hooks/useDirectory';

interface SettingsUpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SettingsUpgradeModal({
  isOpen,
  onClose,
}: SettingsUpgradeModalProps) {
  const me = useDirectoryMe();

  useEffect(() => {
    if (isOpen) {
      (async function () {
        const cal = await getCalApi({ namespace: 'upgrade-modal' });
        cal('ui', {
          hideEventTypeDetails: true,
          layout: 'month_view',
          theme: 'light',
        });
      })();
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl sm:max-w-4xl">
        <DialogTitle className="text-2xl font-bold">
          Unlock Pro (with our help)
        </DialogTitle>
        <div className="p-8 pb-0">
          <div className="flex w-full flex-col gap-6">
            <p className="text-base text-gray-600">
              You&apos;re on the Free plan now. We&apos;d love to walk you
              through what Pro can do — book a call and we&apos;ll custom-tailor
              it for you.
            </p>

            <div className="flex w-full flex-col gap-4">
              <h3 className="text-lg font-semibold">Benefits of Pro:</h3>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <FaCheck className="mr-3 size-5 text-green-500" />
                  <span>Top-tier support (Slack Connect)</span>
                </li>
                <li className="flex items-center">
                  <FaCheck className="mr-3 size-5 text-green-500" />
                  <span>
                    Bring in your existing tools (Google Drive, Notion, etc.)
                  </span>
                </li>
                <li className="flex items-center">
                  <FaCheck className="mr-3 size-5 text-green-500" />
                  <span>Expand your usage — up to 200 pages per user</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Cal.com embed below text with month view layout - full width */}
          <div className="-ml-[33px] mt-6 w-[calc(100%+66px)]">
            <Cal
              namespace="upgrade-modal"
              calLink="team/questionbase/pricing-call"
              style={{ width: '100%', height: '600px' }}
              config={{
                layout: 'month_view',
                theme: 'light',
                name: me.name || '',
                email: me.email || '',
              }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
